import { observable, action, computed, makeObservable } from 'mobx';
import { ProfileApi } from '../../BackEnd/API';
import { KYC_STATUSES } from '../constants/kyc.constants';

class KycStore {
  @observable accessToken;

  @observable loading;

  @observable startedKycProcess;

  @observable status;

  @observable level;

  @observable handling403FromPaymentService;

  @observable handling403FromKycService;

  constructor() {
    makeObservable(this);
  }

  @computed get rejected() {
    return this.status === KYC_STATUSES.rejected;
  }

  @computed get needsInfo() {
    return this.status === KYC_STATUSES.needsInfo;
  }

  @computed get accepted() {
    return this.status === KYC_STATUSES.accepted;
  }

  @computed get processing() {
    return this.status === KYC_STATUSES.processing;
  }

  @action.bound async getStatus() {
    this.loading = true;
    const res = await ProfileApi.getKyc();
    const { status, current_level: currentLevel } = res;
    this.status = status;
    this.level = currentLevel;
    try {
      const { token } = res.data;
      this.accessToken = token;
    } catch (e) {}
    this.loading = false;
  }

  @action.bound async levelUp() {
    await ProfileApi.levelUpKyc();
  }
}

export const kycStore = new KycStore();
